module.exports = __webpack_public_path__ + "media/icons/usa-and-california-flag-7f7c6d8f.png";